import React from 'react';
import { typeLabel, typeAccent } from '../utils';

export default function Tag({ t }) {
  const c = typeAccent(t);
  return (
    <span className="tag" style={{ '--tag': c }} data-type={t}>
      <span className="tagDot" />
      {typeLabel(t)}
    </span>
  );
}
